function check_sidebar(){
  let sidebar = document.querySelector(".sidebar");
  if(sidebar){
    let menu_items = sidebar.querySelector(".menu-primary-navigation-container");
    if(menu_items && menu_items.offsetHeight < 20){
      sidebar.classList.add("d-none");
    }
  }
}

$(document).on("ready", () => {
    check_sidebar();
})